import React from 'react';

import './ButtonSecondary.scss';

const ButtonSecondary = props => (
  <button type="button" onClick={props.onClick} className="button button--secondary">{props.children}</button>
);

export default ButtonSecondary;
